export class DateHelpers {
	//** unused */
	static getLastDayOfNthMonth = function (y: number, m: number) {
		return { day: new Date(y, m + 2, 0).getDate(), year: y, month: m };
	};

	/**
	 * @param {int} The month number, 0 based
	 * @param {int} The year, not zero based, required to account for leap years
	 * @return {Date[]} List with date objects for each day of the month
	 */
	static getDaysInMonth(month: number, year: number) {
		let date = new Date(year, month, 1);
		let days = [];
		while (date.getMonth() === month) {
			days.push(new Date(date));
			date.setDate(date.getDate() + 1);
		}
		return days;
	}

	//** Conver Date to ISO compliant string */
	static dateToISOString = (date: Date) =>
		new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0];

	//** Convert ISO-compliant string to date (yyyy-mm-dd) */
	static isoStringToDate = (dateString: string) => new Date(dateString);

	//** Generates Date list of from given start and end date, including those */
	static generateDateList = (from: Date, to: Date) => {
		const dates = [];
		// Strip hours minutes seconds etc.
		let currentDate = new Date(from.getFullYear(), from.getMonth(), from.getDate());
		while (currentDate <= to) {
			dates.push(currentDate);
			currentDate = new Date(
				currentDate.getFullYear(),
				currentDate.getMonth(),
				currentDate.getDate() + 1 // Will increase month if over range
			);
		}
		return dates;
	};
}
